import { EMBED_ROUTE_NAMES as EMBED_ROUTE_NAMES_FROM_EMBEDS_PACKAGE } from '@townsquare/embeds';

export const EMBED_ROUTE_NAMES = EMBED_ROUTE_NAMES_FROM_EMBEDS_PACKAGE;
